<div class="row">
	<div class="col-xs-12 col-md-12">
		<div class="row">
			<div class="col-12">
				<form class="d-flex align-items-center">
					<div class="d-flex align-items-center mb-3">
						<label class="fw-bold" jhiTranslate="column-filter.level">Level</label>
						<input class="form-control ms-2" name="level" [disabled]="isLoading" type="number" [(ngModel)]="level" (ngModelChange)="levelFieldChanged($event)" min="1" max="20"/>
					</div>
					<div class="mb-3 mb-2">
						<div class="form-check form-check-inline">
							<input class="form-check-input ms-2" id="includeDerivative" name="includeDerivative" [disabled]="isLoading" type="checkbox" [(ngModel)]="includeDerivativeLines" (ngModelChange)="render()"/>
							<label class="form-check-label ms-2 " for="includeDerivative" jhiTranslate="pedigree.tree.include.derivative.lines">Include derivative and maintenance lines </label>
						</div>
						<div class="form-check form-check-inline">
							<input class="form-check-input ms-2" id="includeBreedingMethod" name="includeBreedingMethod" [disabled]="isLoading" type="checkbox" [(ngModel)]="includeBreedingMethod" (ngModelChange)="render()"/>
							<label class="form-check-label ms-2" for="includeBreedingMethod" jhiTranslate="pedigree.tree.include.breeding.method">Include Breeding Method </label>
						</div>
					</div>
					<button class="btn btn-info ms-2 mb-2" (click)="downloadSvg()">
						<i class="fa fa-download"></i>
                        <span class="ms-1" jhiTranslate="download"></span>
                    </button>
					<div *ngIf="isLoading" class="ms-2 mb-2"><span class="throbber"></span></div>
				</form>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<jhi-collapsible heading="{{translateService.instant('pedigree.tree.filter.title')}}">
					<div class="container-fluid">
						<div class="row mb-3">
							<div class="col d-flex align-items-center">
								<label class="fw-bold" jhiTranslate="pedigree.tree.filter.variable">Variable:</label>
                                <div class="ms-2" style="width: 250px;">
                                    <jhi-variable-select name="dropdownvariable" id="dropdownvariable"
                                                         (onVariableSelectedChange)="selectVariable($event)"
                                                         [value]="selectedVariable?.id"
                                                         [variableTypeIds]="VARIABLE_TYPE_IDS"
                                                         [disabled]="isLoading">
                                    </jhi-variable-select>
                                </div>
                                <div class="ms-2 d-flex align-items-center">
                                    <ng-container [ngSwitch]="selectedVariable?.scale?.dataType?.name">
                                        <ng-container *ngSwitchCase="DataType.CATEGORICAL">
                                            <select class="form-select" style="width: 250px;" name="variablevalue" id="variablevalue" [(ngModel)]="categoricalValue" #variablevalue="ngModel" required>
                                                <option *ngFor="let category of selectedVariable.scale.validValues.categories"
                                                        [title]="category.description"
                                                        [value]="category.name">
                                                    <label>{{category.name}}</label>
                                                </option>
                                            </select>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="DataType.CHARACTER">
                                            <input class="form-control" style="width: 250px;" [(ngModel)]="characterValue" type="text" placeholder="{{ 'pedigree.tree.contains' | translate }}">
                                        </ng-container>
                                        <ng-container *ngSwitchCase="DataType.DATE">
                                            <label for="fromDate" class="col-form-label fw-bold ms-2">From: </label>
                                            <div class="input-group ms-2">
                                                <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="fromDate"
                                                       ngbDatepicker #fromDatePicker="ngbDatepicker" id="fromDate" name="date" required/>
                                                <button class="btn btn-outline-secondary calendar" (click)="fromDatePicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                                            </div>
                                            <label for="toDate" class="col-form-label fw-bold ms-2">To: </label>
                                            <div class="input-group ms-2">
                                                <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="toDate"
                                                       ngbDatepicker #toDatePicker="ngbDatepicker" id="toDate" name="date" required/>
                                                <button class="btn btn-outline-secondary calendar" (click)="toDatePicker.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="DataType.NUMERIC">
                                            <label for="minNumberValue" class="col-form-label fw-bold ms-2">From: </label>
                                            <div class="input-group ms-2">
                                                <input class="form-control" [(ngModel)]="minNumberValue" id="minNumberValue" name="minNumberValue" type="number">
                                            </div>
                                            <label for="maxNumberValue" class="col-form-label fw-bold ms-2">To: </label>
                                            <div class="input-group ms-2">
                                                <input class="form-control" [(ngModel)]="maxNumberValue" id="maxNumberValue" name="maxNumberValue" type="number">
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                                <div class="ms-2">
                                    <button class="btn btn-primary" [disabled]="disableHighlightButton()" jhiTranslate="pedigree.tree.filter.highlight" (click)="highlightFilteredNodes()"></button>
                                </div>
							</div>
						</div>
						<div class="row mb-3">
							<div class="col-2.5">
								<label class="fw-bold" jhiTranslate="pedigree.tree.filter.selected">Selected Germplasm:</label>
							</div>
							<div class="col-8">
								<div id="selectedItemsContainer" class="mt-1">
									<span *ngFor="let germplasm of selectedGermplasmList" class="badge secondary tag-text">
										<span *jhiHasAnyAuthority="VIEW_NAMES_PERMISSION">{{ germplasm.germplasmPreferredName }}</span>
										<span *jhiHasNotAnyAuthority="VIEW_NAMES_PERMISSION">{{ germplasm.gid }}</span>
										<button type="button" class="btn-close" (click)="removeSelectedItem(germplasm.gid)"></button>
									</span>
								</div>
							</div>
							<div class="col-1.5 mt-3">
								<button class="btn btn-primary" [disabled]="selectedGermplasmList.length === 0" jhiTranslate="pedigree.tree.filter.save" (click)="openCreateList()"></button>
							</div>
						</div>
					</div>
				</jhi-collapsible>
			</div>
		</div>
	</div>
</div>
<div class="row">
	<div class="col-xs-12 col-md-12">
		<div id="pedigree-graph" class="pedigree-graph"></div>
	</div>
</div>
<div id="context-menu" class="hidden">
	<ul>
		<li *ngIf="!isNodeSelected" id="select-germplasm" (click)="selectNode()" jhiTranslate="pedigree.tree.select.germplasm">Select Germplasm</li>
		<li *ngIf="isNodeSelected" id="deselect-germplasm" (click)="deselectNode()" jhiTranslate="pedigree.tree.deselect.germplasm">Deselect Germplasm</li>
		<li id="open-details" (click)="openGermplasmDetails()" jhiTranslate="pedigree.tree.view.germplasm.details">View Germplasm Details</li>
	</ul>
</div>
